import $ from 'jquery';

class HeaderScroll  {

	constructor(options) {

		this.getIsScrolling = options.getIsScrolling;
		this.isAnchor = false;

		this.checkIfAnchor();
		setTimeout(() => {
			this.detectScroll();
		}, 400);	
			this.doProgressScroll();
	}

	checkIfAnchor() {
		var hash = window.location.hash;

        if( hash ) {

            var urlHash = hash.substring(1);

            setTimeout(() => {
                this.isAnchor = false;
            }, 2000);
        }
	}

	detectScroll() {
		var lastScrollTop = 0;
		var self = this;
		$(window).scroll(function(event){
			var scrollToTop = $(this).scrollTop();
			if( scrollToTop > 100 && !self.getIsScrolling) {
				if (scrollToTop > lastScrollTop){
					$('.header--main').addClass('scrolled');
					if( $('.header--main').hasClass('sticky-anchors') ) {
						$('.header--main').removeClass('sticky-anchors');
					}

				} else {

					$('.header--main').removeClass('scrolled');

				}
				lastScrollTop = scrollToTop;
			}	
		});

	}

	doProgressScroll() {
		
		if( $(".home-hero__background-outer").length < 1 ) {
			return;
		}

		var lastScrollTop = 0;
		var isHidden = false;

		$(window).scroll(function(event){
			var scrollToTop = $(this).scrollTop();
			var homeHeroHeight = $(".home-hero__background-outer").outerHeight();
			if( scrollToTop > homeHeroHeight  ) {
				if (!isHidden){
					$(".slider-progress").hide();
					isHidden = true;
				} 
			}
			else {
				if( isHidden ) {
					$(".slider-progress").show();
					isHidden = false;
				}
			}
		});

	}

}



module.exports = HeaderScroll;